<template>
  <div @click="column.click(row)" class="column-multline" style="font-weight: normal">
    <p>{{row[column.field]}}
      <span v-for="(field, index) in column.lines" :key="index">
        <br/>{{row[field]}}
      </span>
    </p>
  </div>
</template>
<script>
export default {
  name: 'MultLineItem',
  props: ['column', 'row']
}
</script>
